import { render, staticRenderFns } from "./waterMaster01Detail.vue?vue&type=template&id=1f24fe9c"
import script from "./waterMaster01Detail.vue?vue&type=script&lang=js"
export * from "./waterMaster01Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f24fe9c')) {
      api.createRecord('1f24fe9c', component.options)
    } else {
      api.reload('1f24fe9c', component.options)
    }
    module.hot.accept("./waterMaster01Detail.vue?vue&type=template&id=1f24fe9c", function () {
      api.rerender('1f24fe9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/water/mst/waterMaster01Detail.vue"
export default component.exports